function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    background-color: #ffffff;\n    box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 1px;\n    font-weight: 500;\n    filter: drop-shadow(rgb(186, 186, 186) 1px 0px 2px);\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    height: ",
        "px;\n    right: 0;\n    position: fixed;\n    top: 0;\n    z-index: 99;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .header-logo {\n        margin: 1rem;\n        width: 33%;\n\n        img {\n            width: 150px;\n            background-size: cover;\n        }\n    }\n\n    .header-right {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        width: 33%;\n        margin-right: 1rem;\n    }\n\n    span {\n        float: left;\n        padding: 5px;\n        color: #202834;\n        font-size: 16px;\n    }\n\n    button {\n        float: left;\n        font-size: 16px;\n        margin: 0 5px;\n        padding: 5px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
export var HeaderContainer = styled.div(_templateObject(), function(p) {
    return p.height;
});
